<template>
  <div>
    <qx-card title="司机" class="detail" v-loading="loading">
      <!-- 订单详情数据 -->
      <qx-detail-box v-for="(data, index) in detailData" :data="data" :key="index" :labelWidth="'170px'">
        <section slot="mycustomSalaryInfo">
          <template
            v-if="
              data.tableData.data &&
              data.tableData.data.userSalaryInfoList &&
              data.tableData.data.userSalaryInfoList.length
            "
          >
            <p
              class="salary-item"
              v-for="(item, index) in data.tableData.data.userSalaryInfoList"
              :key="index"
            >
              <span>
                <template>
                  <em v-if="data.tableData.data.salaryPattern === 2">里程</em>
                  <em v-if="data.tableData.data.salaryPattern === 3">趟数</em>
                </template>
                区间：{{ item.startNum
                }}
                <template>
                  <em v-if="data.tableData.data.salaryPattern === 2">公里</em>
                  <em v-if="data.tableData.data.salaryPattern === 3">趟</em>
                </template>
                - {{ item.endNum
                }}
                <template>
                  <em v-if="data.tableData.data.salaryPattern === 2">公里</em>
                  <em v-if="data.tableData.data.salaryPattern === 3">趟</em>
                </template>
              </span>
              <span>
                <template>
                  <em v-if="data.tableData.data.salaryPattern === 2">里程</em>
                  <em v-if="data.tableData.data.salaryPattern === 3">趟数</em>
                </template>
                单价：{{ item.priceDouble
                }}
                <template>
                  <em v-if="data.tableData.data.salaryPattern === 2">元/公里</em>
                  <em v-if="data.tableData.data.salaryPattern === 3">元/趟</em>
                </template>
              </span>
            </p>
          </template>
        </section>
      </qx-detail-box>
      <!-- 订单详情数据 end -->
    </qx-card>
    <ApproveBox
      v-if="(type ||$route.query.type) === 'approve'"
      :busiId="id ? String(id) : String(detailData.base.tableData.data.relId)"
      busiCode="100002"
      :inFast="Boolean(id)"
      :handleRefresh="handleRefresh"
    />
  </div>
</template>

<script>
import {
  driverArchivesDetail, // 获取详情
} from 'api/archives';
import ApproveBox from 'components/approveBox';
import {
  getFileUrl,
  approveItemInfo,
} from 'api';
export default {
  components: {
    ApproveBox,
  },
  props: {
    id: {
      type: Number,
    },
    type: {
      type: String,
    },
    handleRefresh: {
      type: Function,
      default: () => {},
    },
  },
  data () {
    return {
      userId: '',
      loading: false,
      detailData: {
        base: {
          label: '基础信息',
          tableData: {
            title: [
              {
                prop: 'mobilePhone',
                label: '司机账号',
              },
              {
                prop: 'linkman',
                label: '司机姓名',
              },
              {
                prop: 'carUserTypeName',
                label: '司机种类',
              },
              {
                prop: 'attachedOrgName',
                label: '归属部门',
              },
            ],
            data: {

            },
            approveData: {

            },
          },
        },
        imgInfo: {
          label: '证件信息',
          tableData: {
            title: [
              {
                prop: 'identification',
                label: '身份证号',
                span: 1,
              },
              {
                prop: 'idenPictureFrontUrl',
                label: '身份证头像面',
                type: 'img',
              },
              {
                prop: 'idenPictureBackUrl',
                label: '身份证国徽面',
                type: 'img',
              },
              {
                prop: 'custom_driverLicenseTime',
                label: '驾驶证有效期',
                span: 1,
              },
              {
                prop: 'adriverLicenseOriginalUrl',
                label: '驾驶证正本',
                type: 'img',
              },
              {
                prop: 'adriverLicenseDuplicateUrl',
                label: '驾驶证副本',
                type: 'img',
              },
              {
                prop: 'qcCertiTypeName',
                label: '从业证类型',
              },
              {
                prop: 'vehicleTypeName',
                label: '准驾车型',
              },
              {
                prop: 'qcCertiTime',
                label: '从业资格证有效期',
              },
              {
                prop: 'qcCertiUrl',
                label: '从业资格证',
                type: 'img',
              },
              {
                prop: 'safetyAgreementUrl',
                label: '安全责任协议',
                type: 'img',
              },
              {
                prop: 'driverContractUrl',
                label: '司机合同',
                type: 'img',
              },
            ],
            data: {

            },
            approveData: {

            },
          },
        },
        salary: {
          label: '司机工资',
          tableData: {
            title: [
              {
                prop: 'entryStateName',
                label: '在职状态',
              },
              {
                prop: 'entryDate',
                label: '入职日期',
              },
              {
                prop: 'salaryPatternName',
                label: '薪资模式',
              },
              // {
              //   prop: 'salaryDouble',
              //   label: '基本工资',
              //   unit: '元/月',
              // },
              // {
              //   prop: 'subsidyDouble',
              //   label: '补贴金额',
              //   unit: '元/天',
              // },
            ],
            data: {

            },
            approveData: {

            },
          },
        },
        car: {
          label: '绑定车辆',
          type: 'array',
          tableData: {
            title: [
              {
                prop: 'plateNumber',
                label: '车牌号码',
              },
              {
                prop: 'vehicleClassName',
                label: '车辆种类',
              },
              {
                prop: 'licenceTypeName',
                label: '牌照类型',
              },
              {
                prop: 'vehicleStatusName',
                label: '车辆类型',
              },
            ],
            data: {

            },
            approveData: {

            },
          },
        },
        bankCard: {
          label: '银行卡信息',
          tableData: {
            title: [
              {
                prop: 'bankPhoneUrl',
                label: '银行卡照片',
                type: 'img',
              },
              {
                prop: 'acctName',
                label: '账户名',
              },
              {
                prop: 'acctNo',
                label: '银行卡号',
              },
              {
                prop: 'bankName',
                label: '开户行',
              },
              // {
              //   prop: 'icbcEcardPhone',
              //   label: '工行E卡注册手机号',
              // },
              {
                prop: 'remark',
                label: '备注',
              },
            ],
            data: {

            },
            approveData: {

            },
          },
        },
      },
    };
  },
  computed: {
    colSpan () {
      const total = 24;
      const minSpan = 4;
      return parseInt(total / this.orderInfo.length, 10) < minSpan ? minSpan : parseInt(total / this.orderInfo.length, 10);
    },
  },
  watch: {
    '$route.query.id': function () {
      this.getData();
    },
  },
  methods: {
    getAttachDisplayUrl (info) {
      if (!info) {
        return '';
      }
      return info.fullPathUrl || info.fullPath || info.url || info.picFullUrl || info.storePath || info.picUrl || '';
    },
    async handleImgUrl (tar, obj) {
      if (!obj || !obj[tar]) {
        return;
      }
      const currentUrl = obj[tar + 'FullUrl'] || obj[tar + 'Url'] || '';
      if (currentUrl && (currentUrl.indexOf('http') === 0 || currentUrl.indexOf('/local-uploads/') === 0)) {
        obj[tar + 'Url'] = currentUrl;
        obj[tar + 'FullUrl'] = currentUrl;
        return;
      }
      const urlRes = await getFileUrl({
        flowIds: obj[tar],
        _GRID_TYPE: 'jq',
      });
      const rows = urlRes && Array.isArray(urlRes.rows) ? urlRes.rows : [];
      const info = rows[0] || urlRes;
      const displayUrl = this.getAttachDisplayUrl(info);
      if (displayUrl) {
        obj[tar + 'Url'] = displayUrl;
        obj[tar + 'FullUrl'] = displayUrl;
      }
    },
    async handleDriverImgUrls (obj) {
      const imgFields = [
        'userPrice', 'idenPictureFront', 'idenPictureBack', 'adriverLicenseOriginal',
        'adriverLicenseDuplicate', 'qcCerti', 'lugeAgreement', 'safetyAgreement',
        'driverContract',
      ];
      for (let i = 0; i < imgFields.length; i++) {
        await this.handleImgUrl(imgFields[i], obj);
      }
    },
    async getData () {
      if (this.$route.path !== '/manage/archives/driver/archives/detail' && !this.id) {
        return;
      }
      this.loading = true;
      const detailRes = await driverArchivesDetail({
        userId: this.userId || this.$route.query.id,
      });
      this.loading = false;
      if (!detailRes.failed) {
        await this.handleDriverImgUrls(detailRes.user);
        await this.handleDriverImgUrls(detailRes.ver);
        if (detailRes.user) {
          const driverLicenseTime = detailRes.user.driverLicenseTime;
          const driverLicenseExpiredTime = detailRes.user.driverLicenseExpiredTime;
          detailRes.user.custom_driverLicenseTime = (this.formatDate(driverLicenseTime) || '缺少开始日期') + ' - ' + (driverLicenseExpiredTime && driverLicenseExpiredTime.includes('9999-12-31') ? '长期' : this.formatDate(driverLicenseExpiredTime) || '缺少到期日期');
        }
        // detailRes.user.modalType = '工资设置（从左到右）';
        this.detailData.base.tableData.data = detailRes.user;
        this.detailData.imgInfo.tableData.data = detailRes.user;
        this.detailData.salary.tableData.data = detailRes.user;
        // 绑定车辆
        if (detailRes.user.vehicleList) {
          detailRes.user.vehicleList.forEach((item) => {
            item.vehicleStatusName = item.vehicleLengthName + item.vehicleStatusName;
          });
          this.detailData.car.tableData.data = detailRes.user.vehicleList;
        }
        // 先找到“薪资模式”的位置，先清除所有添加的列内容
        const salaryPatternNameIndex = this.detailData.salary.tableData.title.findIndex((item) => item.prop === 'salaryPatternName');
        this.detailData.salary.tableData.title.splice(salaryPatternNameIndex + 1);
        if (detailRes.user.salaryPattern) {
          if (detailRes.user.salaryPattern !== 5) {
            if (this.detailData.salary.tableData.title.find((item) => item.prop !== 'salaryDouble')) {
              this.detailData.salary.tableData.title.push({
                label: '基本工资',
                prop: 'salaryDouble',
                unit: '元/月',
              });
            }
            if (this.detailData.salary.tableData.title.find((item) => item.prop !== 'subsidyDouble')) {

              this.detailData.salary.tableData.title.push({
                label: '补贴金额',
                prop: 'subsidyDouble',
                unit: '元/天',
              });
            }
          }
          // if (detailRes.user.salaryPattern === 5) {
          //   if (this.detailData.salary.tableData.title.find((item) => item.prop !== 'basicSalary')) {
          //     this.detailData.salary.tableData.title.push({
          //       label: '底薪',
          //       prop: 'basicSalaryDouble',
          //       unit: '元/月',
          //     });
          //   }
          //   if (this.detailData.salary.tableData.title.find((item) => item.prop !== 'minimumWage')) {
          //     this.detailData.salary.tableData.title.push({
          //       label: '保底工资',
          //       prop: 'minimumWageDouble',
          //       unit: '元/月',
          //     });
          //   }
          // }
          if (detailRes.user.salaryPattern === 3 || detailRes.user.salaryPattern === 4) {
            if (this.detailData.salary.tableData.title.find((item) => item.prop !== 'incomeRatio')) {
              this.detailData.salary.tableData.title.push({
                label: '提成比例',
                prop: 'incomeRatio',
                unit: '%',
              });
            }
          } else {
            this.detailData.salary.tableData.title.forEach((item) => {
              if (item.prop === 'subsidyDouble') {
                item.span = 1;
              }
            });
          }
        }
        if (detailRes.user.userSalaryInfoList) {

          if (this.detailData.salary.tableData.title.find((item) => item.prop !== 'mycustomSalaryInfo')) {
            let labelTypeName = '';
            if (detailRes.user.salaryPattern === 2) {
              labelTypeName = '里程';
            }
            if (detailRes.user.salaryPattern === 3) {
              labelTypeName = '趟数';
            }
            this.detailData.salary.tableData.title.push({
              label: labelTypeName + '工资设置',
              prop: 'mycustomSalaryInfo',
              span: 1,
              slot: true,
            });
          }
        }
        // 银行卡信息
        delete this.detailData.bankCard2;
        if (detailRes.user.accountBankList) {
          if (detailRes.user.accountBankList.length === 1) {
            this.detailData.bankCard.tableData.data = detailRes.user.accountBankList[0];
          } else if (detailRes.user.accountBankList.length > 1) {
            let bandCard2 = JSON.parse(JSON.stringify(this.detailData.bankCard));
            bandCard2.label = '银行卡信息2';
            this.detailData.bankCard2 = bandCard2;
            this.detailData.bankCard.tableData.data = detailRes.user.accountBankList[0];
            this.detailData.bankCard2.tableData.data = detailRes.user.accountBankList[1];
          } else {
            this.detailData.bankCard.tableData.data = {};
          }
        }
        this.detailData.eCard = {
          label: '工行E卡信息',
          tableData: {
            title: [
              {
                prop: 'icbcEcardRegisAccount',
                label: '工行E卡注册账号',
              },
            ],
            data: {

            },
            approveData: {

            },
          },
        };
        this.detailData.eCard.tableData.data = detailRes.user;
        if (this.id || this.$route.query.type) {
          if (detailRes.ver.carUserType === null) {
            // 注：当 carUserType 为 null 时，carUserTypeName 不需要对比，直接改成和 user.carUserTypeName 的值一样就行，这样也没上就不会出现该字段 待审 的字样
            detailRes.ver.carUserTypeName = detailRes.user.carUserTypeName;
          }
          const driverLicenseTime = detailRes.ver.driverLicenseTime;
          const driverLicenseExpiredTime = detailRes.ver.driverLicenseExpiredTime;
          detailRes.ver.custom_driverLicenseTime = (this.formatDate(driverLicenseTime) || '缺少开始日期') + ' - ' + (driverLicenseExpiredTime && driverLicenseExpiredTime.includes('9999-12-31') ? '长期' : this.formatDate(driverLicenseExpiredTime) || '缺少到期日期');
          this.detailData.base.tableData.approveData = detailRes.ver;
          this.detailData.imgInfo.tableData.approveData = detailRes.ver;
          this.detailData.salary.tableData.approveData = detailRes.ver;
          // 绑定车辆
          if (detailRes.ver.vehicleList) {
            detailRes.ver.vehicleList.forEach((item) => {
              item.vehicleStatusName = item.vehicleLengthName + item.vehicleStatusName;
            });
            this.detailData.car.tableData.approveData = detailRes.ver.vehicleList;
          }
          // // 银行卡信息数据处理
          // if (detailRes.user.accountBankVerList) {
          //   if (detailRes.user.accountBankVerList.length === 1) {
          //     this.detailData.bankCard.tableData.approveData = detailRes.user.accountBankVerList[0];
          //   } else if (detailRes.user.accountBankVerList.length > 1) {
          //     let bandCard2 = JSON.parse(JSON.stringify(this.detailData.bankCard));
          //     bandCard2.label = '银行卡信息2';
          //     this.detailData.bankCard2 = bandCard2;
          //
          //     this.detailData.bankCard.tableData.approveData = detailRes.user.accountBankVerList[0];
          //     this.detailData.bankCard2.tableData.approveData = detailRes.user.accountBankVerList[1];
          //   } else {
          //     this.detailData.bankCard.tableData.approveData = {};
          //   }
          // }

        }
      }
    },
  },
  async mounted () {
    if (this.id) {
      const res = await approveItemInfo({
        busiId: this.id,
        busiCode: 100002,
      });
      this.userId = res.userId;
    }
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
@import 'styles/config.scss';
.orderStatusBox {
  overflow: auto;
}
.orderInfoBox {
  margin: 16px 12px 0;
  min-height: 124px;
  border: 1px solid $border-color;
  padding: 24px 16px;
  box-sizing: border-box;
  .title {
    font-size: 16px;
    height: 16px;
    line-height: 16px;
    padding-bottom: 16px;
  }
  .desc,
  .time {
    color: #666;
    line-height: 16px;
  }
  .desc {
    padding-bottom: 12px;
  }
}
.box {
  border-top: 1px solid $border-color;
  border-left: 1px solid $border-color;
  border-right: 1px solid $border-color;
}
.itemLabel {
  background: $grey;
}
.itemLabel,
.itemText {
  height: 48px;
  line-height: 48px;
  padding: 0 24px;
  box-sizing: border-box;
  border-bottom: 1px solid $border-color;
}
.salary-item {
  span {
    display: inline-block;
    width: 250px;
  }
}
</style>
